


































import Vue from 'vue';

export default Vue.extend({
  name: 'ChatMessages',
  methods: {
      parseChatDate(date:string): string {
          let d = new Date(date);
          const h = d.getHours();
          const m = d.getMinutes();
          const s = d.getSeconds();

          const hours = h < 10 ? "0" + h : h;
          const minutes = m < 10 ? "0" + m : m;
          const seconds = s < 10 ? "0" + s : s;

          return `${hours}:${minutes}:${seconds}`;
      }
  },
  computed: {
      event(): any {
          return this.$store.state.event;
      },
      reverseComments(): Array<any> {
          if(!this.event.comments) return [];
          return this.event.comments.slice().filter((c:any) => !c.isDeleted).reverse();
      }
  }
});
